import { type FC, type ReactNode, useLayoutEffect, useState } from "react"
import { createPortal } from "react-dom"

const Portal: FC<{ children: ReactNode }> = ({ children }) => {
	const [container, setContainer] = useState<HTMLDivElement>()

	useLayoutEffect(() => {
		const element = document.createElement("div")
		document.body.appendChild(element)
		setContainer(element)

		return () => {
			document.body.removeChild(element)
			setContainer(undefined)
		}
	}, [])

	if (container === undefined) return null

	return createPortal(children, container)
}

export default Portal
